// src/routes.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ConstructionDiary from './pages/ConstructionDiary';
import { AuthProvider } from './contexts/AuthContext'; // Import the AuthProvider

const RoutesComponent: React.FC = () => {
  return (
    <Router>
      <AuthProvider> {/* Wrap the entire app with AuthProvider */}
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected Routes */}
          <Route path="/construction-diary" element={<ConstructionDiary />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default RoutesComponent;